export const newsData = [
  {
    id: 1,
    title: "Fugu Casino увеличило приветственный бонус до 500%",
    date: "2026-01-15",
    category: "Бонусы",
    excerpt: "Крупнейшее повышение бонуса в индустрии онлайн-гейминга. Новые игроки могут получить до 250 000 рублей на первый депозит."
  },
  {
    id: 2,
    title: "Новые правила отыгрыша: что изменилось в 2026 году",
    date: "2026-01-12",
    category: "Регулирование",
    excerpt: "Ведущие казино снизили требования к вейджеру. Средний коэффициент отыгрыша уменьшился с x45 до x35."
  },
  {
    id: 3,
    title: "ТОП-5 слотов для быстрого отыгрыша бонусов",
    date: "2026-01-10",
    category: "Стратегии",
    excerpt: "Эксперты выявили игры с наибольшей отдачей при отыгрыше приветственных бонусов. Pragmatic Play лидирует в рейтинге."
  },
  {
    id: 4,
    title: "Криптовалютные бонусы: новый тренд онлайн-казино",
    date: "2026-01-08",
    category: "Инновации",
    excerpt: "Казино начали предлагать увеличенные бонусы для депозитов в Bitcoin и Ethereum. Средняя надбавка составляет +50%."
  },
  {
    id: 5,
    title: "Рекордный выигрыш на бонусных фриспинах",
    date: "2026-01-05",
    category: "Выигрыши",
    excerpt: "Игрок из России выиграл 8.5 млн рублей, используя 100 бесплатных вращений от SOL Casino."
  },
  {
    id: 6,
    title: "Кешбэк vs Бонус на депозит: что выгоднее в 2026?",
    date: "2026-01-03",
    category: "Аналитика",
    excerpt: "Математический анализ показал, что для регулярных игроков программы кешбэка приносят на 35% больше прибыли."
  }
];